"use strict";
/**
 * CORS utility functions for API endpoints
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAllowedOrigin = isAllowedOrigin;
exports.setCorsHeaders = setCorsHeaders;
/**
 * Checks if an origin is allowed based on the NEXT_PUBLIC_CORS_ORIGINS environment variable
 * NEXT_PUBLIC_CORS_ORIGINS should be a comma-separated list of domain names
 * Special handling:
 * - 'localhost' is included by default in allowed domains unless env var is set without it
 * - All other domains will be matched with https:// and allow any subdomain
 *
 * @example
 * NEXT_PUBLIC_CORS_ORIGINS=builder.io,vercel.app,orlandohealth.com
 *
 * @param origin The origin to check
 * @returns boolean indicating if the origin is allowed
 */
function isAllowedOrigin(origin) {
    if (!origin)
        return false;
    // Get the allowed origins from environment variable, defaulting to localhost
    const corsOriginsEnv = process.env.NEXT_PUBLIC_CORS_ORIGINS || "localhost";
    const allowedDomains = corsOriginsEnv
        .split(",")
        .map((d) => d.trim())
        .filter(Boolean);
    // Check if it's a localhost origin
    if (/^https?:\/\/localhost:/.test(origin)) {
        return allowedDomains.includes("localhost");
    }
    // For all other domains, match any subdomain with https
    return allowedDomains.some((domain) => {
        const domainRegex = new RegExp(`^https:\/\/([a-zA-Z0-9-]+\.)*${domain.replace(".", "\\.")}$`);
        return domainRegex.test(origin);
    });
}
/**
 * Sets CORS headers on a response if the origin is allowed
 *
 * @param req The Next.js API request
 * @param res The Next.js API response
 * @param allowMethods Array of allowed HTTP methods
 * @returns boolean indicating if CORS headers were set
 */
function setCorsHeaders(req, res, allowMethods = ["GET", "POST", "PUT", "DELETE", "OPTIONS"]) {
    const origin = req.headers.origin;
    if (origin && isAllowedOrigin(origin)) {
        res.setHeader("Access-Control-Allow-Origin", origin);
        res.setHeader("Access-Control-Allow-Methods", allowMethods.join(", "));
        res.setHeader("Access-Control-Allow-Headers", "Content-Type, Authorization");
        return true;
    }
    return false;
}
